import { withAuthRedirect } from '../hocs';
import { useQuery } from '@tanstack/react-query';
import { useContext, useEffect } from 'react';
import { Panel, PanelHeader, PanelContent, Loading } from '../atoms';
import { MerchantUsersList, UsersHeader } from '../organisms';
import { getMerchantUsers, useUsersStore } from '../../contexts/UsersContext';
import { useLoggedInUserStore } from '../../contexts/LoggedInUserContext';
import { UserContext } from '../../contexts';

const MerchantUsersPage = () => {
  const clearState = useUsersStore((s) => s.clearState);
  const setMerchantUsers = useUsersStore((s) => s.setMerchantUsers);
  const merchantUsers = useUsersStore((s) => s.merchantUsers);
  const { user } = useContext(UserContext);
  const merchantId = user.merchantId;
  // const merchantId = useLoggedInUserStore((s) => s.merchant);
  const { isLoading, isFetching, refetch } = getMerchantUsers({
    merchantId,
    setMerchantUsers,
    query: useQuery
  });

  useEffect(() => {
    return () => clearState();
  }, [clearState]);

  const refreshPage = () => {
    refetch();
  };

  return (
    <Panel>
      <PanelHeader>
        <UsersHeader refreshPage={refreshPage} />
      </PanelHeader>
      <PanelContent>
        {isLoading || isFetching ? (
          <Loading />
        ) : (
          <MerchantUsersList
            merchantUsers={merchantUsers}
            refreshPage={refreshPage}
          />
        )}
      </PanelContent>
    </Panel>
  );
};

const SecureCoursesPage = withAuthRedirect(MerchantUsersPage);
export { SecureCoursesPage as MerchantUsersPage };
